const selectors = {
  getSavedInvestments: state => state.investor.get('savedInvestments'),
  getFetchingInvestments: state =>
    state.investor.get('fetchingSavedInvestments')
};

export default selectors;
